import { PropsWithChildren, useRef } from 'react';

import { ReactComponent as IconClose } from '../../../assets/images/signX.svg';
import useOnClickOutside from '../../../hooks/useOnClickOutside/useOnClickOutside';
import {
  StyledCloseCrossIcon,
  StyledHeaderWrapper,
  StyledSideBar,
  StyledSidebarWrapper,
  StyledTitleWrapper,
} from './styled';

type Props = {
  title: string | JSX.Element;
  onCancel: () => void;
  classesToSkip?: string[];
};

const SideBar = ({ children, title, onCancel, classesToSkip = [] }: PropsWithChildren<Props>): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onCancel, classesToSkip);

  return (
    <StyledSidebarWrapper data-testid="wrapperSideBar">
      <StyledSideBar ref={ref} data-testid="sideBarModal">
        <StyledHeaderWrapper>
          <StyledTitleWrapper>{title}</StyledTitleWrapper>
          <StyledCloseCrossIcon data-testid="closeSideBarIcon" onClick={onCancel}>
            <IconClose />
          </StyledCloseCrossIcon>
        </StyledHeaderWrapper>
        {children}
      </StyledSideBar>
    </StyledSidebarWrapper>
  );
};

export default SideBar;
